import React, { FC } from 'react'
import { CollapsibleContainer, CollapsibleContainerBody, CollapsibleContainerHeader } from '@vfuk/core-collapsible-container'
import { v4 as uuid } from 'uuid'
import Link from '@vfuk/core-link'
import Divider from '@vfuk/core-divider'
import ListItem from '@vfuk/core-list-item'

import * as Styled from './styles/MobileLinkList.style'

import { MobileLinkListProps } from './MobileLinkList.types'

const MobileLinkList: FC<MobileLinkListProps> = ({ linkGroups, onInteractionClick }) => {
  return (
    <Styled.MobileLinkListWrapper>
      {linkGroups!.groups.map((group, index) => (
        <React.Fragment key={uuid()}>
          <CollapsibleContainer appearance='primary' inverse isActive={linkGroups!.openOnMD}>
            <CollapsibleContainerHeader>{group.headingText}</CollapsibleContainerHeader>
            <CollapsibleContainerBody key={uuid()}>
              <Styled.LinkListWrapper>
                {group.links.map((link) => (
                  <ListItem key={link.id}>
                    <Link
                      inverse
                      srText={link.srText}
                      href={link.href}
                      customRouterProps={link.customRouterProps}
                      htmlAttributes={{ dataAttributes: link.dataAttributes }}
                      onClick={onInteractionClick}
                    >
                      {link.text}
                    </Link>
                  </ListItem>
                ))}
              </Styled.LinkListWrapper>
            </CollapsibleContainerBody>
          </CollapsibleContainer>
          <If condition={index !== linkGroups!.groups.length - 1}>
            <Divider appearance='secondary' inverse />
          </If>
        </React.Fragment>
      ))}
    </Styled.MobileLinkListWrapper>
  )
}

export default MobileLinkList
